// extracted by mini-css-extract-plugin
export default {"tsrForm":"index_tsrForm__qjnlY","taskTypeForm":"index_taskTypeForm__3XR7-"};